/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { HttpParams } from "@angular/common/http";
import { of, throwError } from "rxjs";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import {
	GET_AVERAGE_CARBON_INTENISTY_RESPONSE,
	GET_CARBON_INTENSITY_BY_REGION_RESPONSE
} from "./regions.db";
import { ApplicationError } from "../../../../models/ui/application-error.model";

export class Regions {
	public static getCarbonIntensityByRegion(options: HttpRequestOptions) {
		const { params, pathParams } = options;

		const httpParams = params as HttpParams;

		if (!httpParams)
			return throwError(
				() =>
					new ApplicationError(
						"No params provided",
						this.constructor.name,
						this.getCarbonIntensityByRegion.name
					)
			);

		const region = pathParams?.["region"];

		if (!region)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required region parameter",
						this.constructor.name,
						this.getCarbonIntensityByRegion.name
					)
			);

		const startDate = httpParams.get("startDate");
		const endDate = httpParams.get("endDate");

		if (!startDate || !endDate)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						this.constructor.name,
						this.getCarbonIntensityByRegion.name
					)
			);

		return of(GET_CARBON_INTENSITY_BY_REGION_RESPONSE);
	}

	public static getAverageCarbonIntensity(options: HttpRequestOptions) {
		const { params } = options;

		const httpParams = params as HttpParams;

		if (!httpParams)
			return throwError(
				() =>
					new ApplicationError(
						"No params provided",
						this.constructor.name,
						this.getAverageCarbonIntensity.name
					)
			);

		const startDate = httpParams.get("startDate");
		const endDate = httpParams.get("endDate");
		const tenantId = httpParams.get("tenantId");

		if (!startDate || !endDate || !tenantId)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						this.constructor.name,
						this.getAverageCarbonIntensity.name
					)
			);

		return of(GET_AVERAGE_CARBON_INTENISTY_RESPONSE);
	}
}
